import React, { useState, useEffect } from "react";
import {
    LocalizationProvider,
    DesktopDateTimePicker,
} from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Base } from "../../framework/base";
import { IconButton, TextFieldProps } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ISingleDateTimePickerProps {
    value: string;
    label?: string;
    onChange: (val: string) => void;
    error?: boolean;
    helperText?: string;
    required?: boolean;
    asUtc?: boolean;
    fullWidth?: boolean;
    disableInputAdornment?: boolean;
    open?: boolean;
    setOpen?: (open: boolean) => void;
    textFieldProps?: TextFieldProps;
    showCloseIcon?: boolean;
}

export const MuiSingleDateTimePicker = ({
    value,
    onChange,
    error,
    helperText,
    required,
    label,
    asUtc = true,
    fullWidth,
    disableInputAdornment,
    open,
    setOpen,
    textFieldProps = {},
    showCloseIcon,
}: ISingleDateTimePickerProps) => {
    const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(
        dayjs(value)
    );

    useEffect(() => {
        if (value) {
            setSelectedDate(dayjs(value));
        }
    }, [value]);

    const handleDateChange = (date: Dayjs | null) => {
        setSelectedDate(date);
        if (date) {
            onChange(
                asUtc ? date.toISOString() : Base.dayjsToJsonDateTime(date)
            );
        } else {
            onChange("");
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fi">
            <DesktopDateTimePicker
                open={open}
                onClose={!!setOpen ? () => setOpen(false) : undefined}
                label={label}
                value={selectedDate}
                onChange={handleDateChange}
                format="D.M.YYYY H:mm"
                slots={{
                    toolbar: null,
                    inputAdornment: disableInputAdornment
                        ? () => null
                        : undefined,
                }}
                slotProps={{
                    textField: {
                        helperText,
                        error: !!error,
                        required,
                        fullWidth,
                        onClick: !!setOpen ? () => setOpen(true) : undefined,
                        InputProps: { sx: textFieldProps.sx },
                        ...textFieldProps,
                    },
                }}
            />
            {showCloseIcon ? (
                <IconButton size="small" onClick={() => handleDateChange(null)}>
                    <CloseIcon fontSize="inherit" />
                </IconButton>
            ) : null}
        </LocalizationProvider>
    );
};
